import apiClient from "../helpers/api_client";

export const getReplacementPricingAssets = ({
  assetValuationId,
  assetCategoryId,
  name,
  condition,
  description,
  pricingStatus,
  includeAllReviewStatuses,
  page = 0,
  size = 25,
} = {}) => {
  const params = { assetValuationId, page, size };
  if (assetCategoryId) params.assetCategoryId = assetCategoryId;
  if (Array.isArray(name) && name.length > 0) {
    params.name = name.join("||");
  } else if (name) {
    params.name = name;
  }
  if (condition) params.condition = condition;
  if (Array.isArray(description) && description.length > 0) {
    params.description = description.join("||");
  } else if (description) {
    params.description = description;
  }
  if (pricingStatus && pricingStatus !== "all") params.pricingStatus = pricingStatus;
  if (includeAllReviewStatuses) params.includeAllReviewStatuses = true;

  return apiClient.get("/assets/replacement-pricing", { params });
};

export const getReplacementPricingFilterOptions = ({
  assetCategoryId,
  name,
  condition,
  pricingStatus,
} = {}) => {
  const params = {};
  if (assetCategoryId) params.assetCategoryId = assetCategoryId;
  if (Array.isArray(name) && name.length > 0) {
    params.name = name.join("||");
  } else if (name) {
    params.name = name;
  }
  if (condition) params.condition = condition;
  if (pricingStatus && pricingStatus !== "all") params.pricingStatus = pricingStatus;
  return apiClient.get("/assets/replacement-pricing/filter-options", { params });
};

export const getReplacementPricingProgress = () =>
  apiClient.get("/assets/replacement-pricing/progress");

export const exportReplacementPricingNamedColumns = ({
  assetValuationId,
  assetCategoryId,
  name,
  condition,
  description,
  pricingStatus,
} = {}) => {
  const params = {};
  if (assetValuationId) params.assetValuationId = assetValuationId;
  if (assetCategoryId) params.assetCategoryId = assetCategoryId;
  if (Array.isArray(name) && name.length > 0) {
    params.name = name.join("||");
  } else if (name) {
    params.name = name;
  }
  if (condition) params.condition = condition;
  if (Array.isArray(description) && description.length > 0) {
    params.description = description.join("||");
  } else if (description) {
    params.description = description;
  }
  if (pricingStatus && pricingStatus !== "all") params.pricingStatus = pricingStatus;

  return apiClient.get("/assets/replacement-pricing/named-export.xlsx", {
    params,
    responseType: "blob",
  });
};

export const exportReplacementPricingUsersDaily = ({ startDate, endDate } = {}) => {
  const params = {};
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;

  return apiClient.get("/assets/replacement-pricing/users-daily-export.xlsx", {
    params,
    responseType: "blob",
    suppressGlobalError: true,
  });
};

export const applyReplacementPricing = ({ assetIds, unitCurrentReplacementCost }) =>
  apiClient.post("/assets/replacement-pricing/apply", {
    asset_ids: assetIds,
    unit_current_replacement_cost: unitCurrentReplacementCost,
  });

export const getAssetPricingFormulas = () =>
  apiClient.get("/asset-pricing-formulas");

export const updateAssetPricingFormula = (id, payload) =>
  apiClient.put(`/asset-pricing-formulas/${id}`, payload);

export const exportAssetPricingFormulas = () => {
  return apiClient.get("/asset-pricing-formulas/export", {
    responseType: "blob",
    suppressGlobalError: true,
  });
};

export const exportGamisTemplate = ({ assetCategoryCode, maxRows, institutionSearch, institutionIds, useConfiguredNames, condition } = {}) => {
  const params = {};
  if (assetCategoryCode) params.assetCategoryCode = assetCategoryCode;
  if (maxRows) params.maxRows = maxRows;
  if (institutionSearch) params.institutionSearch = institutionSearch;
  if (Array.isArray(institutionIds) && institutionIds.length > 0) {
    params.institutionIds = institutionIds.join(",");
  } else if (institutionIds) {
    params.institutionIds = institutionIds;
  }
  if (useConfiguredNames !== undefined) params.useConfiguredNames = useConfiguredNames;
  if (condition) params.condition = condition;

  return apiClient.get("/assets/template-export.xlsx", {
    params,
    responseType: "blob",
    suppressGlobalError: true,
  });
};

export const exportGamisTemplateZipped = ({ assetCategoryCode, maxRows, institutionSearch, institutionIds, useConfiguredNames, condition } = {}) => {
  const params = {};
  if (assetCategoryCode) params.assetCategoryCode = assetCategoryCode;
  if (maxRows) params.maxRows = maxRows;
  if (institutionSearch) params.institutionSearch = institutionSearch;
  if (Array.isArray(institutionIds) && institutionIds.length > 0) {
    params.institutionIds = institutionIds.join(",");
  } else if (institutionIds) {
    params.institutionIds = institutionIds;
  }
  if (useConfiguredNames !== undefined) params.useConfiguredNames = useConfiguredNames;
  if (condition) params.condition = condition;

  return apiClient.get("/assets/template-export-zipped.zip", {
    params,
    responseType: "blob",
    suppressGlobalError: true,
  });
};

export const exportFinalReport = ({ categoryCode } = {}) => {
  const params = {};
  if (categoryCode) params.categoryCode = categoryCode;

  return apiClient.get("/assets/final-report/export.xlsx", {
    params,
    responseType: "blob",
    suppressGlobalError: true,
  });
};
